import { graphql } from '~/contentful/graphql';

export const Newsletter_NewsletterFragment = graphql(`
  fragment Newsletter_NewsletterFragment on NewsletterCard {
    description
    disclaimer
  }
`);
